<template>
  <div class="navbar-header d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <RouterLink class="navbar-brand" to="/">
          <span class="brand-logo">
            <b-img :src="appLogoImage" alt="logo" />
          </span>
          <h2 class="brand-text mb-0">
            {{ appName }}
          </h2>
        </RouterLink>
      </li>
    </ul>
  </div>
</template>

<script>
import { $themeConfig } from "@themeConfig";
import { BImg } from "bootstrap-vue";
import { RouterLink } from "vue-router";

export default {
  components: {
    RouterLink,
    BImg,
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app;
    return {
      appName,
      appLogoImage,
    };
  },
};
</script>

<style></style>
